import { render, staticRenderFns } from "./kalendar-container.vue?vue&type=template&id=fc65b920&"
import script from "./kalendar-container.vue?vue&type=script&lang=js&"
export * from "./kalendar-container.vue?vue&type=script&lang=js&"
import style0 from "./main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports